import React from "react";

import { formatMinorUnits } from "../../utils/money";

const ReceiptRow = ({ label, amount, total = false }) => (
  <div
    className={`table-offer__row${total ? " table-offer__row--total" : ""}`}
  >
    <dt>{label}</dt>
    <dd>{amount}</dd>
  </div>
);

const TableOfferCard = ({ offer, booked = false }) => {
  const money = (value) => formatMinorUnits(value, offer.currency);
  const seatLine = `${offer.seats} seats`;

  return (
    <section
      className={`table-offer${booked ? " table-offer--booked" : ""}`}
      aria-labelledby="table-offer-title"
    >
      <div className="table-offer__head">
        <div>
          <h2 className="table-offer__title" id="table-offer-title">
            {offer.tableName}
          </h2>
          {offer.tierName ? (
            <p className="table-offer__tier">{offer.tierName}</p>
          ) : null}
        </div>
        {booked ? <span className="table-offer__badge">Booked</span> : null}
      </div>
      {offer.description ? (
        <p className="table-offer__description">{offer.description}</p>
      ) : null}
      <p className="table-offer__seats">Seats {offer.seats}, you included</p>
      <dl className="table-offer__receipt">
        <ReceiptRow
          label={offer.tierName ? `${offer.tierName} · ${seatLine}` : seatLine}
          amount={money(offer.subtotal)}
        />
        {offer.fees ? (
          <ReceiptRow label="Service charges" amount={money(offer.fees)} />
        ) : null}
        <ReceiptRow
          label={booked ? "Paid" : "Total"}
          amount={money(offer.total)}
          total
        />
      </dl>
    </section>
  );
};

export default TableOfferCard;
